import React from 'react'
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material'
import {
    selectionControlSx,
    selectionControlLabelProps,
} from '@/Components/Elements/StyledComponents/Input'
import { BlockFormState } from '../../types'

interface PermissionsTabProps {
    kedo: any
    state: BlockFormState
    onChangeRole: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const PermissionsTab: React.FC<PermissionsTabProps> = ({
    kedo,
    state,
    onChangeRole,
}) => {
    return (
        <FormGroup sx={{ gap: 0.5 }}>
            {state.availableRoles.map((item: any) => (
                <FormControlLabel
                    {...selectionControlLabelProps}
                    key={item.id}
                    control={
                        <Checkbox
                            size="small"
                            value={item.id}
                            checked={state.item.roles.includes(item.id)}
                            onChange={onChangeRole}
                            sx={(theme) => selectionControlSx(theme)}
                        />
                    }
                    label={item.name}
                    sx={{
                        ...selectionControlLabelProps.sx,
                        display: 'flex',
                        alignItems: 'center',
                        m: 0,
                        ml: '-6px',
                    }}
                />
            ))}
        </FormGroup>
    )
}

export default PermissionsTab
